import React, { Component } from "react";
import Modal from "react-modal";
import { connect } from "react-redux";
import {
  selectAydinlatma,
  getAydinlatma,
  setAydinlatma,
  hideAydinlatmaModal
} from "../../../state/ducks/common/index";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    border: "none",
    padding: "0",
    background: "none"
  }
};

Modal.setAppElement("#app");

class AydinlatmaMetni extends Component {
  componentDidMount() {
    this.props.getAydinlatma();
  }

  hideModal = () => {
    this.props.setAydinlatma();
  };

  render() {

    const { aydinlatma } = this.props;
    return (
      <Modal
        isOpen={aydinlatma?.durum === false}
        onRequestClose={this.closeModal}
        style={{
          overlay: {
            position: 'fixed',

            inset: "0% 0% 0% 0%",
            left: 0,
            right: 0,

            bottom: 0,
            backgroundColor: 'unset !important'
          },
          content: {
            position: 'fixed',
            width: '100%',
            height: '100%',
            overflow: 'hidden',
            top: 0,
            left: 0,
            padding: "0px",
            border: '0px',
            backgroundColor: 'transparent' /* Black w/ opacity */

          }
        }}
      >

        {/* Bu kısım animasyon için Hareket eden kısım. */}
        <div className="t-modalContent" id="id-modalTipi" style={(window.innerWidth <= 900) ? { width: "89%" } : { width: "60%" }}>
          <div
            className="t-modal"
            id="id-modalGenel"
            style={{ backgroundColor: "rgb(255, 255, 255)" }}
          >
            <div className="container-fluid">
              {/* Header */}
              <div className="row t-modalHeader">
                <div
                  className="col text-center"
                  id="id-modalHeader"
                  style={{ color: "rgb(119, 119, 119)" }}
                >
                  KİŞİSEL VERİLERİN KORUNMASI AYDINLATMA VE BİLGİLENDİRMESİ
                </div>
                <div className="col-auto t-cursorPointer">

                </div>
              </div>
              {/* Body */}
              <div className="row t-modalBody">
                <div
                  className="col-12"
                  id="id-modalBody"
                  style={{ color: "rgb(119, 119, 119)" }}
                  dangerouslySetInnerHTML={{ __html: aydinlatma?.kvkkMetni }}
                ></div>

                <br /> <br />

                <div className="w-100">
                  <button
                    className="t-icButtonYesil mx-auto"
                    onClick={() => this.hideModal()}
                  >
                    <span>Onaylıyorum</span>
                    <i className="t-icon-done_outline" />
                  </button>
                </div>
              </div>
              {/* footer*/}
              {/* <div className="row t-modalFooter">
          <div
            className="col-12"
            id="id-modalFooter"
            style={{ color: "rgb(102, 102, 102)" }}
          >
            <p>
              <strong>E-Posta Adresi:</strong>{" "}
              <a href="mailto:kvkk@eminevim.com.tr">kvkk@eminevim.com.tr</a>
              <br />
              <strong>Veri Sorumlusu Adı-Soyadı:</strong>&nbsp;&nbsp;EMİN EVİM
              EMİN OTOMOTİV İLETİŞİM ORG. SAN. VE TİC. A.Ş
            </p>
          </div>
        </div> */}
            </div>
          </div>
        </div>


      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    aydinlatma: selectAydinlatma(state)
  };
};

const mapDispatchToProps = dispatch => ({
  hideAydinlatmaModal: () => dispatch(hideAydinlatmaModal()),
  getAydinlatma: () => dispatch(getAydinlatma()),
  setAydinlatma: () => dispatch(setAydinlatma())
});

export default connect(mapStateToProps, mapDispatchToProps)(AydinlatmaMetni);
